import { ButtonLink } from "../components/ButtonLink";
import { PageHeader } from "../components/PageHeader";
import { Seo } from "../components/Seo";

export function NotFound() {
  return (
    <>
      <Seo title="Page Not Found" description="The requested Zion Classical Academy page could not be found." />
      <PageHeader eyebrow="404" title="Page not found">
        The page you requested is not available.
        <span className="inline-action"><ButtonLink href="/" variant="gold">Return home</ButtonLink></span>
      </PageHeader>
    </>
  );
}
